import { userStore, res } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { server } from "typescript";
export default {
    async getList(page: number, size: number, title: string | null): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "community/list",
                {
                    page: page,
                    size: size,
                    title: title,
                },
                { withCredentials: false },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },

    async add(title: string, content: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/community/add",
                {
                    title: title,
                    content: content,
                },
                { withCredentials: false },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async addComment(idx: string, content: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/community/comment/add",
                {
                    idx: idx,
                    content: content,
                },
                { withCredentials: false },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async addReComment(idx: number, content: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/community/reComment/add",
                {
                    idx: idx,
                    content: content,
                },
                { withCredentials: false },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async getDetail(index: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/community/" + index, { withCredentials: false });
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async like(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/community/good/" + idx, null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async bad(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/community/bad/" + idx, null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async commentGood(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/community/commentGood/" + idx, null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async commentBad(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/community/commentBad/" + idx, null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async getComment(idx: string, pageNum: number, size:number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/community/comment/list",
                {
                    idx: idx,
                    page: pageNum,
                    size: size,
                },
                {
                    withCredentials: false,
                },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async getReComment(idx: number | string, pageNum: number, size:number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/community/reComment",
                {
                    idx: idx,
                    page: pageNum,
                    size: size,
                },
                {
                    withCredentials: false,
                },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async deleteComment(idx: number | string,): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/community/comment/delete/"+idx,
                {
                    withCredentials: false,
                },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async modifyContent(idx:string, title:string, content:string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/community/modify",
                {
                    idx,
                    title,
                    content
                }
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async modifyComment(idx:number, content:string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/community/comment/modify",
                {
                    idx,
                    content
                },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async deleteContent(idx:number): Promise<res>{
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/community/delete/"+idx,
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;

    }
};
